import { Home, Subscriptions, ThumbUpOffAlt, MusicNote, Lightbulb, EmojiEvents } from '@mui/icons-material';

export const categories = [
    ['Home',Home],['Subscriptions',Subscriptions],['Liked-Videos',ThumbUpOffAlt],['Music',MusicNote],['Sports',EmojiEvents],['Learning',Lightbulb]
];